<template>
  <div>
    <a-modal
      v-model="visible"
      :title="$t('common_btn_switch_comp')"
      :maskClosable="false"
      :footer="null"
      @cancel="cancelClose"
    >
      <!-- 数据加载时 -->
      <div style="text-align: center;">
        <a-spin tip="Loading..." :spinning="isLoading" />
      </div>
      <ul class="company-list" v-if="!isLoading">
        <template v-if="subjectList.length > 0">
          <li
            class="company"
            :class="{'active': item.isEffective === 1 &&  activeSubjectId ? activeSubjectId === item.subjectId  : false,
            'disabled': item.isEffective === 0 }"
            v-for="item in subjectList"
            :key="item.subjectId"
            @click="chocieSubject(item)"
          >
            <img class="company-avater" src="@/assets/company.png" alt="" />
            <span class="company-text">{{ item.companyName }}</span>
          </li>
          <li class="certification" v-if="isCredentials">{{$t('common_globalcomp_to_create_company')}}，<a href="javascript:;" @click="_CreateOpenApiCompany" >{{$t('common_globalcomp_to_create_certification')}}</a></li>
        </template>

        <template v-else>
          <li>{{$t('common_globalcomp_unusable_enterprise')}}<a href="javascript:;" @click="_CreateOpenApiCompany" >{{$t('common_globalcomp_to_create_certification')}}</a></li>
        </template>
      </ul>
    </a-modal>
  </div>
</template>
<script>
import { GetSubjectList, CreateOpenApiCompany, SsoGetSubjectAuthentications, SsogetUserRoleMenu, SsoGetUserInfo } from '@/api/login'
import { mapState } from 'vuex'
import { openNotificationWithIcon } from '@/utils/util'
import { ACCESS_TOKEN, ACCESS_SUNID } from '@/store/mutation-types'
export default {
  data () {
    return {
      visible: false,
      subjectList: [],
      activeSubjectId: '',
      isLoading: false
    }
  },
  methods: {
    _GetSubjectList () {
      this.isLoading = true
      GetSubjectList()
        .then(res => {
          this.isLoading = false
          const { data } = res
          this.subjectList = data
        })
    },
    _CreateOpenApiCompany () { // 创建注册主体，去认证
      CreateOpenApiCompany()
        .then(res => {
          if (res.code === '200') {
            this.$store.commit('SET_IS_CHOICE_SUBJECT', false)
            this._SsoGetUserInfo() // 重新拉取一下
            this.$router.push('/work/credentials')
          } else {
            openNotificationWithIcon(res.message)
            this.$store.commit('SET_IS_CHOICE_SUBJECT', false)
            this.$ls.remove(ACCESS_TOKEN)
            this.$ls.remove(ACCESS_SUNID)
            this.$router.push('/home')
          }
        })
    },
    goToCredentials () { // 去认证
      this.$store.commit('SET_IS_CHOICE_SUBJECT', false)
      this.$router.push('/work/credentials')
    },
    // 获取注册主体信息
    _SsoGetUserInfo () {
      SsoGetUserInfo().then(res => {
        if (res.code === '200') {
          this.$store.commit('SET_SUBJECT_NAME', res.data.onlineSubjectName)
          this.$store.commit('SET_SUBJECT_ID', res.data.onlineSubjectId)
          SsoGetSubjectAuthentications({
            // subjectId: res.data.onlineSubjectId
          }).then((res) => { // 根据主体区查询认证、审核状态
            const { code, message, dataList } = res
            if (code === '200') {
              this.$store.commit('SET_COMPANY_INFO', dataList[0]) // Vuex存储个人认证信息
              this.$store.dispatch('_SET_TO_OTHERMENU', (dataList || [])) // 判断是否能够进入其他菜单
            } else {
              openNotificationWithIcon(message)
            }
          })
          if (res.data.userType === 0) { // 此时登录后，需要去认证 弹窗
            this.$store.commit('SET_IS_CREDENTIALS', true)
          } else {
            this.$store.commit('SET_IS_CREDENTIALS', false)
          }
          // 查询菜单
          SsogetUserRoleMenu({ systemCode: 'OPEN_API_PORTAL' }).then((res) => {
            const { code, message, data } = res
            if (code === '200') {
              this.$store.commit('SET_LEFT_MENU', data)
            } else {
              openNotificationWithIcon(message)
            }
          })
        } else {
          openNotificationWithIcon(res.message)
        }
      })
    },
    // 选择公司主体
    chocieSubject (item) {
      if (item.isEffective === 0) return false
      this.$store.dispatch('_SsogetUserRoleMenu', { ...item, reset: true })
    },
    cancelClose (e) {
      this.$store.commit('SET_IS_CHOICE_SUBJECT', false)
    }
  },
  computed: {
    ...mapState({
      'isShow': state => state.isLogin.isChoiceSubject,
      'isCredentials': state => state.isLogin.isCredentials // userType === 0
    })
  },
  beforeMount () {
    // const whiteList = ['/Agreement', '/PolicyModal']
    // const token = this.$ls.get(ACCESS_TOKEN)

    // if (token) {
    //   this._SsoGetUserInfo()
    //   this.$store.dispatch('_SsoGetUserInfo')
    // } else {
    //   if (whiteList.includes(this.$route.path)) return // 路由拦截
    //   this.$router.push('/home')
    // }
  },
  watch: {
    isShow (val) {
      if (val) {
        this.visible = true
        this.activeSubjectId = this.$store.state.isLogin.subjectId
        this._GetSubjectList()
      } else {
        this.visible = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .company-list {
    margin: 0;
    padding: 0;
    list-style:none;
    min-height: 80px;
    li.company {
      margin-top: 10px;
      padding: 4px 10px 6px;
      &:first-child {
        margin-top: 0px;
      }
      &:hover {
        color: #1890ff;
        background-color: #e6f7ff;
        cursor: pointer;
      }
    }
    li.active {
      color: #1890ff;
      background-color: #e6f7ff;
    }
    li.disabled {
      color: #999999;
      &:hover {
        color: #999999;
        background-color: transparent;
        cursor: not-allowed;
      }
    }
    li.no-data {
      margin-top: 10px;
      padding: 5px 10px;
    }
    .company-avater {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
    .company-text {
      width: 400px;
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space:nowrap;
    }
    .certification {
      margin-top: 20px;
      color: #999999
    }
  }
</style>
